import Image from "next/legacy/image";
import { useSelector } from "react-redux";

function NoChats() {
  const lang = useSelector(({ common }) => common?.language);
  return (
    <div className='mt-[0px] mb-[90px] flex flex-col items-center justify-center'>
      <Image
        src='/assets/no-comments.svg'
        alt='No comments icon'
        width={80}
        height={80}
      />
      <p className='mb-0 text-[16px] font-bold text-[#616161]'>
        {lang?.common?.no_chats_yet}
      </p>
      {/* <p className='mb-0 text-[12px] text-[#757575]'>Be the first to comment</p> */}
    </div>
  );
}


export default NoChats;